import { cx } from '@linaria/core';
import { useSpeechSynthesisConfig } from '@provider/speech-synthesis';
import { breakpoints } from '@ui/css';
import { SpeechButton } from '@ui/kit';
import { useFullscreenState, useMatchBreakpoint } from '@utils/react';
import { mobileLightboxLayoutBreakpoint, selectors, contentWrapper } from '../../root.component/_component.style.js';
import '@i-ark/models';
import '@utils/component-framework';
import 'react';
import '@tanstack/react-query';
import { selectOriginalComponentVersion } from '../../state/selectors/data.original-version.js';
import { iArkStore } from '../../state/store.js';
import { transition } from '../_content.style.js';
import { useUserOwnsEntry } from '../hook.user-owns-entry.js';
import { speechSynthesisButton, tokens, separator, speechSynthesisWrapper, tools } from './_tools.style.js';
import { useZoomActions } from './hooks/useZoomActions.js';
import { ContextMenuTool } from './tool.context-menu.js';
import { FullscreenTool } from './tool.fullscreen.js';
import { LineTool } from './tool.line.js';
import { ZoomInTool } from './tool.zoom-in.js';
import { ZoomOutTool } from './tool.zoom-out.js';
import { jsx } from 'react/jsx-runtime';

function IArkTools(props) {
  const speechConfig = useSpeechSynthesisConfig();
  const zoom = useZoomActions(props.componentProps.context, props.contentRef);
  const {
    fullscreenEnabled
  } = useFullscreenState();
  const isFullscreen = fullscreenEnabled || props.componentProps.context === "lightbox";
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  const isMobileLightbox = useMatchBreakpoint(mobileLightboxLayoutBreakpoint);
  const entryKey = iArkStore.useSelector(state => state.entryKey);
  const originalComponentVersion = iArkStore.useSelector(selectOriginalComponentVersion);
  const userOwnsEntry = useUserOwnsEntry(entryKey);
  const buttons = (() => {
    const output = [];
    if (isMobileLightbox && isFullscreen) {
      output.push({
        type: "button",
        key: "contextmenu",
        element: /*#__PURE__*/jsx(ContextMenuTool, {
          ...props,
          ...props.componentProps
        })
      });
      output.push({
        type: "separator",
        key: "sep"
      });
    }
    if (originalComponentVersion === 1 && userOwnsEntry) {
      output.push({
        type: "button",
        key: "line",
        element: /*#__PURE__*/jsx(LineTool, {})
      });
      if (!isMobileLightbox || !isFullscreen) {
        output.push({
          type: "separator",
          key: "sep"
        });
      }
    }
    if (isFullscreen) {
      output.push({
        type: "button",
        key: "zoom-out",
        element: /*#__PURE__*/jsx(ZoomOutTool, {
          ...zoom
        })
      });
      output.push({
        type: "button",
        key: "zoom-in",
        element: /*#__PURE__*/jsx(ZoomInTool, {
          ...zoom
        })
      });
    }
    if (!(isMobile && isFullscreen) && props.componentProps.context !== "lightbox") {
      output.push({
        type: "button",
        key: "fullscreen",
        element: /*#__PURE__*/jsx(FullscreenTool, {
          ...props,
          rootSelector: props.rootSelector,
          overlayId: props.overlayContainerId
        })
      });
    }
    const scrollContainerRef = {
      current: props.contentRef.current?.querySelector(`.${transition}`) ?? null
    };
    if (speechConfig.enabled && (isFullscreen || props.componentProps.context !== "embedded")) {
      const selector = isFullscreen ? `${selectors.wrapper()}[id="${props.rootId}"] > .${contentWrapper}` : `${selectors.wrapper()}[id="${props.rootId}"]`;
      output.push({
        type: "button",
        key: "speech",
        element: /*#__PURE__*/jsx(SpeechButton, {
          className: speechSynthesisButton,
          rootSelector: selector,
          flagPlacement: "top",
          tooltipPlacement: "bottom",
          scrollContainerRef: scrollContainerRef
        }, "speech")
      });
    }
    return output;
  })();
  return /*#__PURE__*/jsx("ul", {
    className: cx(tools, props.className),
    style: tokens.buttonCount.__override(buttons.filter(it => it.type === "button").length),
    children: buttons.map(it => /*#__PURE__*/jsx("li", {
      className: cx(it.key === "speech" && speechSynthesisWrapper),
      children: it.type === "separator" ? /*#__PURE__*/jsx("hr", {
        className: separator
      }) : it.element
    }, it.key))
  });
}

export { IArkTools };
//# sourceMappingURL=_tools.js.map
